import { render, staticRenderFns } from "./LoginWay.vue?vue&type=template&id=34cab2ec&scoped=true&"
import script from "./LoginWay.vue?vue&type=script&lang=js&"
export * from "./LoginWay.vue?vue&type=script&lang=js&"
import style0 from "./LoginWay.vue?vue&type=style&index=0&id=34cab2ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cab2ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34cab2ec')) {
      api.createRecord('34cab2ec', component.options)
    } else {
      api.reload('34cab2ec', component.options)
    }
    module.hot.accept("./LoginWay.vue?vue&type=template&id=34cab2ec&scoped=true&", function () {
      api.rerender('34cab2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/comp/LoginWay.vue"
export default component.exports